import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

// =================================
// GET POSTPAID APPROVAL USERS
// =================================

export const getPostpaidApprovals =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/subscription/api/admin/postpaid/approvals`,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Postpaid Approvals Error:",
                error
            );

            throw error;
        }
    };

export const getAllUsers = async (
    token
) => {
    try {

        const response =
            await axios.get(
                `${BASE_URL}/subscription/api/admin/getallusers`,
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                        Authorization:
                            `Bearer ${token}`,
                    },
                }
            );

        return response.data;

    } catch (error) {

        console.error(
            "GET All Users Error:",
            error
        );

        throw error;
    }
};


export const getAllFoodOrdersAPI =
    async (signal) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const headers =
                token
                    ? {
                        Authorization:
                            `Bearer ${token}`,
                    }
                    : {};

            const response =
                await fetch(
                    `${BASE_URL}/food/api/orders`,
                    {
                        headers,

                        signal,
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            const data =
                await response.json();

            return Array.isArray(data)
                ? data
                : [];

        } catch (error) {
            console.error(
                "❌ Fetching food orders error:",
                error
            );

            throw error;
        }
    };

export const getUserProfileByIdAPI =
    async (userId) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "No auth token found. Please login first."
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/subscription/api/user/getprofile/${userId}`,
                    {
                        method: "GET",

                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            if (!response.ok) {
                throw new Error(
                    "Failed to fetch user profile"
                );
            }

            const data =
                await response.json();

            return data;

        } catch (error) {
            console.error(
                "❌ Error fetching user profile:",
                error
            );

            throw error;
        }
    };


// ================= UPDATE POSTPAID APPROVAL STATUS =================
export const updatePostpaidApprovalStatusAPI =
    async (
        professionalUserId,
        restaurantName,
        status
    ) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Auth token missing. Please login again."
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/subscription/api/admin/postpaid/approval/update?professionalUserId=${professionalUserId}&restaurantName=${encodeURIComponent(
                        restaurantName
                    )}&status=${status}`,
                    {
                        method: "PUT",

                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            if (!response.ok) {
                let errorMessage =
                    `Status: ${response.status}`;

                try {
                    const errorText =
                        await response.text();

                    if (errorText) {
                        errorMessage =
                            errorText;
                    }
                } catch (e) { }

                throw new Error(
                    errorMessage
                );
            }

            try {
                return await response.json();
            } catch {
                return {
                    success: true,
                };
            }

        } catch (error) {
            console.error(
                "❌ Error updating approval status:",
                error
            );

            throw error;
        }
    };